import React, { useEffect, useState } from "react";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import { Box, Button, Container, Typography } from "@mui/material";
import Header from "../components/common/Header";
import ErrorAnimation from "../components/Lottie/ErrorAnimation";
import KycAnimation from "../components/Lottie/KycAnimation";
import DocumentVerified from "../components/Lottie/DocumentVerified";

export default function RedirectionURL() {
  return (
    <>
      <Container maxWidth={false} sx={{ maxWidth: "425px" }}>
        <Header showBar={false} disabledBackBtn={true} showLogoutBtn={false} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "90vh",
          }}
        >
          {/* <KycAnimation /> */}
          <DocumentVerified />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="h2" color="primary" sx={{ mt: 1, mb: 2 }}>
              Your aadhar verification is done kindly closed the page
            </Typography>
          </Box>
        </Box>
      </Container>
    </>
  );
}
